if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

if (!customElements.get('media-switcher')) {
  customElements.define(
    'media-switcher',
    class MediaSwitcher extends HTMLElement {
      constructor() {
        super();
        this.togglers = this.querySelectorAll('.js-toggle-media');
        this.main_items = this.querySelectorAll('.js-main-media');
        this.toggle_wrapper = this.querySelector('.media-preview');
        this.togglers.forEach(toggler => {
          toggler.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            window.pauseAllMedia();
            this.togglers.forEach(t => t.classList.remove('is-active'));
            this.main_items.forEach(t => t.classList.add('hidden'));
            toggler.classList.add('is-active');
            const id = toggler.dataset.mediaId;
            const activeMainMedia = this.querySelector(`.js-main-media[data-media-id="${id}"]`);
            if (activeMainMedia) {
              activeMainMedia.classList.remove('hidden');
              
              // Auto-play videos when switching media
              const deferredMedia = activeMainMedia.querySelector('deferred-media');
              if (deferredMedia) {
                const deferredTemplate = deferredMedia.querySelector('template');
                const deferredContent = deferredTemplate ? deferredTemplate.content : null;
                if (deferredContent) {
                  // Check for any video type (YouTube, Vimeo, or regular video)
                  const hasVideo = deferredContent.querySelector('.js-youtube, .js-vimeo, video');
                  if (hasVideo) {
                    deferredMedia.loadContent();
                  }
                }
              }
              
              // Initialize magnify functionality for images when switching
              if (window.enableZoomOnHover) {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    window.enableZoomOnHover(2, activeMainMedia);
                  }, 150);
                });
              }
            }

            this.toggle_wrapper.scrollTo({
              left: toggler.offsetLeft,
              top: toggler.offsetTop,
              behavior: 'smooth'
            });
          })
        })
      }


    }
  );
}


